import { useGetAllPersons } from '@hr/api/endpoints'
import { IconAverage } from '@hr/common/icons'
import { LoadingContainer } from '@hr/common/loaders/loadingcontainer'
import { localized, median } from '@hr/common/utils'
import { useTranslation } from 'react-i18next'
import styles from './Card.module.css'
import { determineSalary } from './SalaryLevelsGrouped'

export function SalaryDiffMedian() {
	const { t } = useTranslation()
	const { data: persons } = useGetAllPersons()

	const countDiff = () => {
		const men = []
		const women = []
		persons.forEach((person) => {
			const status = person.employmentDetails?.personStatus
			if ((status === 'EMPLOYED' || !status) && person.socSec) {
				const { salaryDetails } = person
				if (salaryDetails) {
					const salary = determineSalary(salaryDetails)
					if (salary) {
						const g = (person.gender || '').trim().toUpperCase()
						if (g === 'M') men.push(salary)
						else if (g === 'N') women.push(salary)
					}
				}
			}
		})

		const menMedian = median(men) || 0
		const womenMedian = median(women) || 0
		const diff = Math.abs(menMedian - womenMedian)
		const gap = Math.max(menMedian, womenMedian) === 0 ? 0 : diff / Math.max(menMedian, womenMedian)

		return (
			<>
				<h4 className={styles.cardHeader}>{t('SalaryDiffMedian', 'Palkkaero % (mediaani)')}</h4>
				<IconAverage />
				<b className={styles.bigFigure}>{`${localized.numberFormatFraction1.format(gap * 100)} %`}</b>
			</>
		)
	}

	return persons ? countDiff() : <LoadingContainer />
}
